import { FC, useEffect } from "react";

import { PageLimitProps, filterOutPagesInOtherSections, usePageLimits } from "./helper";
import { PagesCard } from "./topic/activity/detail/PagesCard";

import { CoreUserRoleType } from "components/server-types";
import { t } from "i18n/i18n";
import { Card } from "mds/components/Card";
import { storeApi, useAppSelector } from "store/index";
import {
  activitySelectors,
  selectCurrentSectionId,
  selectReadyForAssessmentPages,
} from "store/selectors";
import { useListSelector } from "store/store-hooks";

type ReadyForAssessmentPagesListProps = PageLimitProps & {
  shouldLinkSidebar?: boolean;
  role?: CoreUserRoleType;
};

// Note: If a role is provided we get pages for that role accross multiple sections.  If not we get current section pages
export const ReadyForAssessmentPagesList: FC<ReadyForAssessmentPagesListProps> = ({
  showAll,
  onCountChanged,
  shouldLinkSidebar,
  role,
}) => {
  const sectionId = useAppSelector(selectCurrentSectionId);
  const activities = useListSelector(activitySelectors.filterForCurrentSection);
  const hasRole = !!role;

  const readyforAssessmentPages = useListSelector((s) => selectReadyForAssessmentPages(s, role));
  const displayPages = usePageLimits(
    filterOutPagesInOtherSections(readyforAssessmentPages),
    showAll,
    onCountChanged,
    hasRole,
  );

  const header = t(`section.sidebar.planner.ready_for_assessment`);

  useEffect(() => {
    if (!sectionId) {
      return;
    }

    storeApi.pages.list({ section_id: sectionId });
    storeApi.activities.list({ section_id: sectionId });
  }, [sectionId]);

  if (!displayPages.length) {
    return (
      <>
        <div className="m-2 text-black-tint-40">{header}</div>
        <Card className="mb-3" small>
          <div className="body-s p-2 font-light text-black-tint-40">
            {t("section.sidebar.planner.no_pages_recently_assessed")}
          </div>
        </Card>
      </>
    );
  }

  return (
    <PagesCard
      activities={activities}
      header={header}
      pages={displayPages}
      shouldLinkSidebar={shouldLinkSidebar}
      showSectionTitle={hasRole}
    />
  );
};
